import React, { useCallback } from 'react';
import { If } from 'common/src/components';
import { UserAvatar } from 'businessCommon/src/components';
import { Account } from '../../type';
import { getName, getAvatar } from '../../util';

interface IProps {
    user: Account;
    onSelectUser: (user: Account) => void;
}

export const AccountItem = ({ user, onSelectUser }: IProps) => {
    const name = getName(user);

    const ref = useCallback(
        (node: HTMLDivElement) => {
            if (node && user.preSelect) {
                node.scrollIntoView({
                    block: 'end',
                });
            }
        },
        [user.preSelect],
    );

    const selectUser = (e: React.MouseEvent | React.TouchEvent) => {
        onSelectUser(user);
        e.stopPropagation();
        e.preventDefault();
        return false;
    };

    const avatar = getAvatar(user);
    return (
        <div
            ref={ref}
            onTouchEnd={selectUser}
            onMouseDown={selectUser}
            className={`result-item ${user.preSelect ? 'pre-select' : ''}`}
        >
            <If condition={!!avatar}>
                <UserAvatar className="avatar" width={28} src={avatar} />
            </If>
            <span className="result-item-name umu-text-clamp clamp-1">{name}</span>
        </div>
    );
};
